import { GridColDef } from "@mui/x-data-grid-premium";
import { Card } from "@mui/material";
import StrongKidsRows from "../model";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import StrongKidsCreate from "../create";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import { useTranslate } from "src/locales";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return <ByzGrdEditButton link={`edit/${params.row.id}`} />;
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <ByzGrdDeleteButton onClick={() => console.log(params.row.id)} />
    ),
  },
];



function createData(point: string, risk: string, intervention: string) {
  return { point, risk, intervention };
}

function StrongKidsList() {
  const { t } = useTranslate();
  const rows = [
    createData(
      "4-5",
      t("strong-kids.high-risk"),
      t("strong-kids.high-risk-description")
    ),
    createData(
      "1-3",
      t("strong-kids.medium-risk"),
      t("strong-kids.medium-risk-description")
    ),
    createData(
      "0",
      t("strong-kids.low-risk"),
      t("strong-kids.low-risk-description")
    ),
  ];

  return (
    <BaseMedCardList
      title={t("strong-kids.strong-kids.title")}
      columns={columns}
      rows={StrongKidsRows}
      CreateComponent={StrongKidsCreate}
      pageSize={10}
    >
      <Card sx={{ p: 3, mt: 3 }}>
        <Table
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell>{t("strong-kids.point")}</TableCell>
              <TableCell align="center">{t("strong-kids.risk")}</TableCell>
              <TableCell align="center">
                {t("strong-kids.intervention-and-follow-up")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.point}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.point}
                </TableCell>
                <TableCell align="left">{row.risk}</TableCell>
                <TableCell align="left">{row.intervention}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </BaseMedCardList>
  );
}
export default StrongKidsList;
